export class SeededRng {
  private state: number;

  constructor(seed: number) {
    this.state = seed >>> 0 || 0x6d2b79f5;
  }

  next(): number {
    let value = (this.state += 0x6d2b79f5);
    value = Math.imul(value ^ (value >>> 15), value | 1);
    value ^= value + Math.imul(value ^ (value >>> 7), value | 61);
    return ((value ^ (value >>> 14)) >>> 0) / 4294967296;
  }

  integer(min: number, maxInclusive: number): number {
    return min + Math.floor(this.next() * (maxInclusive - min + 1));
  }

  pick<T>(values: readonly T[]): T {
    if (values.length === 0) throw new Error('Cannot pick from an empty list');
    return values[Math.floor(this.next() * values.length)]!;
  }

  snapshot(): number {
    return this.state >>> 0;
  }

  restore(value: number): void {
    this.state = value >>> 0;
  }
}

export function shuffle<T>(values: readonly T[], rng: SeededRng): T[] {
  const result = [...values];
  for (let index = result.length - 1; index > 0; index -= 1) {
    const other = rng.integer(0, index);
    [result[index], result[other]] = [result[other]!, result[index]!];
  }
  return result;
}
